import type { ConnectedWallet, WalletProviderId } from "./types";

export interface StoredWalletSession {
  version: 3;
  authorization: string;
  expiresAt: number;
  paymentAddress: string;
  ordinalsAddress?: string;
  paymentPublicKey?: string;
  ordinalsPublicKey?: string;
  provider?: WalletProviderId;
  ordinalsVerified?: boolean;
}

export function sessionMatchesWallet(session: StoredWalletSession | undefined, wallet: Pick<ConnectedWallet, "payment" | "ordinals" | "provider">, verifyOrdinals = false): session is StoredWalletSession {
  return !!session && session.expiresAt > Date.now()
    && session.paymentAddress === wallet.payment.address
    && session.ordinalsAddress === wallet.ordinals.address
    && (!session.paymentPublicKey || session.paymentPublicKey === wallet.payment.publicKey)
    && (!session.ordinalsPublicKey || session.ordinalsPublicKey === wallet.ordinals.publicKey)
    && (!session.provider || session.provider === wallet.provider)
    && (!verifyOrdinals || session.ordinalsVerified === true);
}
